import React, { Component } from 'react';
import { DatePicker, Select} from 'antd';
import Header from '../Common/Component/Header';
import Sidebar from '../Common/Component/Sidebar';
import quickbook from '../../Assets/images/quickbook.png';

class Html extends Component {
  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />

          <div className="aside-area pt-0 account_module_wrapper  sales-item">
            <aside className="laside">
              <h3>Accounting Summary</h3>
              <div className="form-group">
                <div className="fitem">
                  <DatePicker
                    className="swhite summry_date_picker"
                    format="MMM YYYY"
                    placeholder=""
                    allowClear={false}
                    suffixIcon={<i className="las la-angle-down"></i>}/>
                </div>
              </div>
                
              <div className="gray_box">
                <div className="card-body">
                  <div className="flex">
                    <div className="flex-1">
                      <h4 className="mb-0">All Invoices</h4>
                      <h6 className="mb-0">June 2020</h6>
                    </div>
                    <div className="flex-1">
                      <h2 className="text-right">$85,234.67</h2>
                    </div>                        
                  </div>    
                  <div className="flex">
                    <div className="label">
                      <h6>Recurring Services</h6>
                      <h6>Product Sales</h6>
                      <h6>Commission</h6>
                    </div>
                    <div className="value">
                      <h6>$65,123.46</h6>
                      <h6>$15,234.21</h6>
                      <h6>$9,242.01</h6>
                    </div>
                  </div>                   
                </div>
                <div className="card-footer">
                  <h6 className="mb-0 text-center"><u>Jump to Accounts Receivable Aging Summary</u></h6>
                </div>
              </div>

              <div className="gray_box">
                <div className="card-body">
                  <div className="flex">
                    <div className="flex-1">
                      <h4 className="mb-0">All Invoices</h4>
                      <h6 className="mb-0">June 2020</h6>
                    </div>
                    <div className="flex-1">
                      <h2 className="text-right">$85,234.67</h2>
                    </div>                        
                  </div>                                      
                </div>
                <div className="card-footer">
                  <h6 className="mb-0 text-center"><u>Jump to Sales Tax</u></h6>
                </div>
              </div>

              <div className="gray_box">
                <div className="card-body">
                  <div className="flex">
                    <div className="flex-1">
                      <h4 className="mb-0">All Invoices</h4>
                      <h6 className="mb-0">June 2020</h6>
                    </div>
                    <div className="flex-1">
                      <h2 className="text-right">$85,234.67</h2>
                    </div>                        
                  </div> 
                  <p>This shows services and products fulfilled, but are due to be invoiced on the next cycle.</p>                                     
                </div>
                <div className="card-footer">
                  <h6 className="mb-0 text-center"><u>Jump to Sales Tax</u></h6>
                </div>
              </div>

              <div className="mt-10">
                <h6 className="mb-0">Other Reports</h6>
                <u><b>Expiring Customer Payment Methods</b></u>
              </div>

              <div className="syncbook">
                <img src={quickbook} alt="" />
                <u className="mt-10 d-block"><b>Force Resync with Quickbooks</b></u>
              </div>
            </aside>

            <div className="main p-0 d-none">
              <div className="block-row">
                <div className="status-blocks">
                  <div className="overdue stcell">
                    <div className="flex flex-start ai-center">
                      <h2>25</h2>
                      <h4>$4,552.12</h4>
                    </div>                            
                    <p>OVERDUE</p>
                  </div>                                 
                  <div className="open stcell mr-2">
                    <div className="flex flex-start ai-center">
                      <h2>25</h2>
                      <h4>$4,552.12</h4>
                    </div>                            
                    <p>OPEN INVOICES</p>
                  </div>                                  
                  <div className="paid stcell">
                    <div className="flex flex-start ai-center">
                      <h2>25</h2>
                      <h4>$4,552.12</h4>
                    </div>                            
                    <p>PAID LAST 30 DAYS</p>
                  </div>   
                </div>   
              </div>               
            </div>
            {/* Month Forecast starts here*/}
            <div className="block-row">
              <div className="filter_wrapper p-0">
                <div className="left_side">
                  <h2 className="m-0">Sales by Item</h2>
                </div>
                <div className="right_side">
                  <div className="form-group flex ai-center fltr-txt">
                    <div className="fitem">
                      <Select className="swhite"></Select>
                    </div>
                    <div className="fitem">
                      <Select className="swhite"></Select>
                    </div>
                  </div>
                  <div className="forecast-block">
                    <div className="mtable">

                    </div>     
                  </div>
                </div>
              </div>
              <div className="frtable">
                {/* header */}
                <div className="frtop">
                  <div className="frleft">
                    <p>Franchise: Place County, CA <br/> for period May 2020</p>
                  </div>                 
                </div>
                {/* Heading */}
                <div className="frhead">
                  <div className="frleft">
                    <h4>Product Sales</h4>
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> <h4>Items</h4> </div>
                      <div className="flex-1"> <h4>$8,753.02</h4> </div>
                    </div>
                  </div>
                </div>
                {/* Body */}
                <div className="frbody">
                  <div className="frleft">
                    <p>Residential Services</p>
                    <ul>
                      <li>Scooping</li>
                      <li>Treatments</li>
                      <li>Regular Service</li>
                    </ul>
                    <p> Commercial Services</p>                      
                    <p>Pet Waste Station Cleaning </p>      
                    <p>Shipping & Handling</p>   
                    <p>Products - Other</p>                
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> 
                        <p>4035</p>
                        <ul>
                          <li>$12,860.60</li>
                          <li>$270.00</li>
                          <li>$398.00</li>
                        </ul>
                        <p>534</p>                           
                        <p>660</p>
                        <p>00</p>
                        <p>98</p>                                                      
                      </div>
                      <div className="flex-1"> $8,753.02 </div>
                    </div>
                  </div>
                </div>
                {/* Heading */}
                <div className="frhead">
                  <div className="frleft">
                    <h4>Services</h4>
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> <h4>Items</h4> </div>
                      <div className="flex-1"> <h4>$8,753.02</h4> </div>
                    </div>
                  </div>
                </div>
                {/* Body */}
                <div className="frbody">
                  <div className="frleft">
                    <p>Residential Services</p>
                    <ul>
                      <li>Scooping</li>
                      <li>Treatments</li>
                      <li>Regular Service</li>
                    </ul>
                    <p> Commercial Services</p>                      
                    <p>Pet Waste Station Cleaning </p>      
                    <p>Shipping & Handling</p>   
                    <p>Products - Other</p>                
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> 
                        <p>37</p>
                        <ul>
                          <li>60</li>
                          <li>00</li>
                          <li>85</li>
                        </ul>
                        <p>37</p>                           
                        <p>60</p>
                        <p>50</p>
                        <p>90</p>                                                      
                      </div>
                      <div className="flex-1"> 
                        <p>$8,753.02</p> 
                        <p>$8,753.02</p>
                        <p>$8,753.02</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Heading */}
                <div className="frhead">
                  <div className="frleft">
                    <h4>Discount</h4>
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> <h4>Items</h4> </div>
                      <div className="flex-1"> <h4>$8,753.02</h4> </div>
                    </div>
                  </div>
                </div>
                {/* Body */}
                <div className="frbody">
                  <div className="frleft">
                    <p>Residential Services</p>
                    <ul>
                      <li>Scooping</li>
                      <li>Treatments</li>
                      <li>Regular Service</li>
                    </ul>
                    <p> Commercial Services</p>                      
                    <p>Pet Waste Station Cleaning </p>      
                    <p>Shipping & Handling</p>   
                    <p>Products - Other</p>                
                  </div>
                  <div className="frright">
                    <div className="flex">
                      <div className="flex-1"> 
                        <p>50</p>
                        <ul>
                          <li>50</li>
                          <li>50</li>
                          <li>50</li>
                        </ul>
                        <p>50</p>                           
                        <p>50</p>
                        <p>50</p>
                        <p>50</p>                                                      
                      </div>
                      <div className="flex-1"> 
                        <p>$8,753.02</p> 
                        <p>$8,753.02</p> 
                      </div>
                    </div>
                  </div>
                </div>
                {/* Footer */}
                <div className="frfoot">
                  <div className="frleft">
                    <h4>Sales total for franchise for period</h4>
                  </div>
                  <div className="frright">
                    <div className="flex">                      
                      <div className="flex-1">
                        <h4>$168,705.43</h4>
                      </div>
                    </div>                            
                  </div>
                </div>
              </div>
             
            </div>
            {/* Month Forecast ends here*/}
          </div>
        </div>
      </div>
    );
  }
}

export default Html;